import { roleAndTechSkillReduxActions } from "./roleAndTechSkills.action";

const initialState = {
  jobRoles: [],
  job_role_id: undefined,
  job_role_text: null,
  skills_by_role_data: [],
  selected_skills_data: [],
  all_skills: [],
  selected_role_skills: [],
  role: [],
  skill_search_result: [],
  yearsOfExperience: null,
  languages: [], // The master data of all languages
  languageProficiencyTypes: [], // The master data of all proficiency types
  languageProficiencyLevels: [], // The master data of all proficiency levels
  developerLanguageProficiencies: [], // The languages selected by the talent along with their proficiency levels
  languageIdsToBeDeleted: [], // The languages that are to be deleted
};

function RoleAndTechSkillsReducer (state = initialState, action) {
  const { type = '', payload = null } = { ...action };
  switch (type) {
    case roleAndTechSkillReduxActions.UPDATE_ROLE_TECH_SKILLS_STATE_DATA: {
        return { ...state, ...payload }
    }
    case roleAndTechSkillReduxActions.RESET_STATE_DATA: {
        return {...initialState}
    }
    case roleAndTechSkillReduxActions.API_REQUEST_SUCCESS:
    case roleAndTechSkillReduxActions.API_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}

export default RoleAndTechSkillsReducer;
